export default __webpack_public_path__ + "static/media/zodiac11.bd2b79c9.png";